'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports['default'] = _react2['default'].createClass({

  displayName: 'Demo.Controls.InputCheckbox',

  propTypes: {
    value: _react.PropTypes.bool.isRequired,
    onChange: _react.PropTypes.func.isRequired
  },

  handleChange: function handleChange() {
    this.props.onChange(!this.props.value);
  },

  render: function render() {
    return _react2['default'].createElement('input', {
      type: 'checkbox',
      checked: this.props.value,
      onChange: this.handleChange
    });
  }

});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-demo/dist/Controls/InputCheckbox.js
// module id = 962
// module chunks = 0